import React from "react";
import {Page} from "../../interface/model/page";

function PaginationLabel(number, totalPage, pageMoveHandler) {
    let array = new Array();
    let limitIndex = 0, breakIndex =0;
    if(number <= 3) {
        breakIndex = 1;
    }
    else if (number > 3) {
        breakIndex = number-3;
    }
    limitIndex = breakIndex + 8;
    for(let i=1; i<=totalPage; i++) {
        if (breakIndex <= i && limitIndex >= i)
            array.push(
                (number === i-1)
                    ? <li key={`paginationKey-${i}`} className={'on'}>{i}</li>
                    : <li key={`paginationKey-${i}`} onClick={() => pageMoveHandler(i)}>{i}</li>
            )
    }

    return array;
}

interface PaginationData {
    page : Page,
    pageMoveHandler : (pageNumber) => void
}

export function Pagination({ page, pageMoveHandler } : PaginationData ) {
    return page !== undefined && (
            <div className="nv_table_pagenum">
                <ul>
                    <li className="first"
                        onClick={() => pageMoveHandler(0)}>처음으로</li>
                    {
                        page.first
                            ? <li className="prev">이전으로</li>
                            : <li className="prev" onClick={() => pageMoveHandler(page.number)}>이전으로</li>
                    }
                    {
                        PaginationLabel(page.number, page.totalPages, pageMoveHandler).map(row => (row))
                    }
                    {
                        page.last
                            ? <li className="next">다음으로</li>
                            : <li className="next" onClick={() => pageMoveHandler( page.number+2)}>다음으로</li>
                    }
                    <li className="last"
                        onClick={() => pageMoveHandler(page.totalPages )}>마지막으로</li>
                </ul>
            </div>
    )
}